<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8"
                 :sm="24">
            <a-form-item label="配置名称">
              <a-input v-model="query.configName"
                       placeholder="请输入配置名称进行模糊查询"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8"
                 :sm="24">
            <a-form-item label="配置编码">
              <a-input v-model="query.configCode"
                       placeholder="请输入配置编码进行模糊查询"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8"
                 :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="addOrUpdateHandle()"
                        v-action:add>新增</a-button>
              <a-button type="danger"
                        style="margin-left: 8px"
                        @click="deleteSelectRow()"
                        v-action:del>删除</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="exportHandle()"
                        :loading="exportLoading"
                        v-action:export>导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id"
             :row-selection="{selectedRowKeys: this.selectedRows,onChange: onSelectChange }"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
             :data-source="list"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="false">
      <a-tag :color="text? 'blue':'red'"
             slot="canEdit"
             slot-scope="text">{{ text ? '是' : '否' }}</a-tag>
      <span slot="createTime"
            slot-scope="text">{{ text | moment }}</span>
      <span slot="action"
            slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)"
           v-if="record.canEdit"
           v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作"
             style="top: 20px;"
             :width="800"
             v-model="addOrUpdateVisible"
             @ok="handleOk"
             @cancel="handleCancel">
      <a-form class="tenant-form"
              :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="配置编码"
                     hasFeedback>
          <a-input :disabled="this.isUpdate"
                   placeholder="请输入配置编码"
                   v-decorator="['configCode',{ rules: [{ required: true, message: '请输入配置编码' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="配置名称"
                     hasFeedback>
          <a-input placeholder="配置名称"
                   v-decorator="['configName',{ rules: [{ required: true, message: '请输入配置名称' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="配置值"
                     hasFeedback>
          <a-input placeholder="配置值"
                   v-decorator="['configValue',{ rules: [{ required: true, message: '请输入配置值' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="是否可修改">
          <a-select v-decorator="['canEdit',{ rules: [{ required: true, message: '请选择可否修改' }] }]">
            <a-select-option :value="1">Yes</a-select-option>
            <a-select-option :value="0">No</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'

const columns = [
  {
    title: '配置名称',
    dataIndex: 'configName'
  },
  {
    title: '配置编码',
    dataIndex: 'configCode'
  },
  {
    title: '配置值',
    dataIndex: 'configValue'
  },
  {
    title: '是否可修改',
    dataIndex: 'canEdit',
    scopedSlots: { customRender: 'canEdit' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  }, {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'MenuList',
  data () {
    return {
      queryUrl: 'manager/configs/page',
      addOrUpdateUrl: 'manager/configs',
      queryOneUrl: 'manager/configs',
      deleteUrl: 'manager/configs',
      exportDataUrl: 'manager/configs/export',
      query: {
        configName: '',
        configCode: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns
    }
  },
  filters: {
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () {
  },
  methods: {},
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
